var $9366fe642464ee83$exports = {};
$9366fe642464ee83$exports = {
    "dropzoneLabel": `Droppsone`,
    "selectPlaceholder": `Velg et element`,
    "tableResizer": `St\xf8rrelsesendrer`
};


export {$9366fe642464ee83$exports as default};
//# sourceMappingURL=nb-NO.module.js.map
